import type { InvoiceOfferFeeRate } from '@klear/invoice-offer-fee-rate'
import { trpc } from '@klear/ui/lib/trpc'
import { useMutationWithToast, createToastConfig } from '@klear/ui/hooks/use-mutations-with-toast'

const invalidateQueries = ['funderPricing.listInvoiceOfferFeeRates', 'funderPricing.getInvoiceOfferFeeRate']

export function useInvoiceOfferFeeRateMutations() {
  const createMutation = useMutationWithToast(
    trpc.funderPricing.createInvoiceOfferFeeRate.useMutation,
    createToastConfig<InvoiceOfferFeeRate>('Invoice offer fee rate', 'create'),
    { invalidateQueries }
  )

  const updateMutation = useMutationWithToast(
    trpc.funderPricing.updateInvoiceOfferFeeRate.useMutation,
    createToastConfig<InvoiceOfferFeeRate>('Invoice offer fee rate', 'update'),
    { invalidateQueries }
  )

  const deleteMutation = useMutationWithToast(
    trpc.funderPricing.deleteInvoiceOfferFeeRate.useMutation,
    createToastConfig<boolean>('Invoice offer fee rate', 'delete'),
    { invalidateQueries }
  )

  return {
    createInvoiceOfferFeeRate: createMutation.mutateAsync,
    updateInvoiceOfferFeeRate: updateMutation.mutateAsync,
    deleteInvoiceOfferFeeRate: deleteMutation.mutateAsync,
    isCreating: createMutation.isPending,
    isUpdating: updateMutation.isPending,
    isDeleting: deleteMutation.isPending
  }
}

export function useFunderRateSettingsMutation() {
  const updateMutation = useMutationWithToast(
    trpc.funder.update.useMutation,
    createToastConfig('Funder rate settings', 'update'),
    { invalidateQueries: ['funder.list'] }
  )

  return {
    updateFunderRateSettings: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending
  }
}
